<template>
  <div>
    <h4>АБ-тест</h4>

    <table v-if="abTest !== null" class="prop-table mb-4">
      <tr>
        <th>Прототип</th>
        <td>
          <span class="custom-code">{{ abTest.id | getProtoAlias }}</span>
        </td>
      </tr>
      <tr>
        <th>Группа</th>
        <td>
          {{ abTest.group }}
        </td>
      </tr>
    </table>

    <p v-if="abTest === null">
      Нет АБ-теста.
    </p>
  </div>
</template>

<script>
export default {
  name: 'DerbyABTest',

  props: {
    abTest: {
      type: Object,
    }
  },
}
</script>
